import React, { useState, useEffect, useCallback, memo } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { rateMessage } from 'services/elvis';

const POSITIVE = 1;
const NEGATIVE = 0;

const RatingBtn = ({ onClick, icon, active, colour, disabled }) => {
    const [hovered, setHovered] = useState(false);
    const btnClass = classNames({ 'text-secondary': !hovered && !active, [`text-${colour}`]: hovered || active });
    return (
        <Button
            variant='sm'
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={btnClass}>
            <FontAwesomeIcon size='sm' icon={icon} />
        </Button>
    );
}

RatingBtn.propTypes = {
    onClick: PropTypes.func,
    icon: PropTypes.object,
    active: PropTypes.bool,
    colour: PropTypes.string,
    disabled: PropTypes.bool
};

const MessageRater = ({ id, rating }) => {
    const [currentRating, setCurrentRating] = useState(rating ?? null);
    const [saving, setSaving] = useState(false);

    useEffect(() => setCurrentRating(rating ?? null), [rating]);

    const submitRating = useCallback(async clicked => {
        const newRating = currentRating === clicked ? null : clicked;
        const previousRating = currentRating;

        setCurrentRating(newRating);
        setSaving(true);
        try {
            await rateMessage(id, newRating);
            toast.success('Your rating has been saved.');
        } catch {
            setCurrentRating(previousRating);
            toast.error('Could not save your rating. Please try again later.');
        } finally {
            setSaving(false);
        }
    }, [currentRating, id]);

    return (
        <>
            <RatingBtn
                onClick={() => submitRating(POSITIVE)}
                icon={faThumbsUp}
                active={currentRating === POSITIVE}
                colour='success'
                disabled={saving} />
            <RatingBtn
                onClick={() => submitRating(NEGATIVE)}
                icon={faThumbsDown}
                active={currentRating === NEGATIVE}
                colour='danger'
                disabled={saving} />
        </>
    );
};

MessageRater.propTypes = {
    id: PropTypes.number,
    rating: PropTypes.number
};

export default memo(MessageRater);
